"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchSokosite = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const ActionTypes = require("../../actionTypes/sokosite/current");
const Actions = require("../../actions/sokosite/current");
const sok_types_1 = require("@caddigital/sok-types");
const errorHandling_1 = require("../../utils/errorHandling");
function fetchSokosite(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.FETCH_REQUEST), (0, operators_1.mergeMap)((action) => {
        return ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: getToken()
            },
            method: 'GET',
            url: `${baseUrl}api/${action.isMeter ? 'trmvrmeter' : 'worksitediary'}/${action.payload}`
        }).pipe((0, operators_1.mergeMap)((xhr) => {
            if (action.isMeter) {
                return sok_types_1.TRMVRMeter._iTRMVRMeter
                    .decode(xhr.response)
                    .fold((error) => (0, rxjs_1.of)(Actions.fetchFailed((0, errorHandling_1.parseValidationError)(error), true)), (meter) => (0, rxjs_1.of)(Actions.fetchSuccess(meter, true)));
            }
            else {
                return sok_types_1.WorksiteDiary._iWorksiteDiary
                    .decode(xhr.response)
                    .fold((error) => (0, rxjs_1.of)(Actions.fetchFailed((0, errorHandling_1.parseValidationError)(error), false)), (worksitediary) => (0, rxjs_1.of)(Actions.fetchSuccess(worksitediary, false)));
            }
        }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.fetchFailed((0, errorHandling_1.parseAjaxErrorResponse)(error), false))));
    }));
}
exports.fetchSokosite = fetchSokosite;
//# sourceMappingURL=current.js.map